import { TActState } from "../services/banner";
import { MonthsLan } from "./language/texts";
export const formatDate = (timeStamp, language = "en") => {
    const date = new Date(timeStamp);
    const monthArr = MonthsLan[language] || MonthsLan["en"];
    const year = date.getFullYear().toString();
    const month = monthArr[date.getMonth()];
    const day = date.getDate().toString();
    switch (language) {
        case "es":
        case "pt":
            return `${day} de ${month} de ${year}`;
        default:
            return `${day} ${month} ${year}`;
    }
};
export const formatMinutesAndSeconds = (leftTime, state) => {
    if (leftTime > -1) {
        const onlyOnGoing = state === TActState.OnGoing ? EnFormateDays(leftTime) * SECONDS_IN_A_DAY : 0;
        const newTime = leftTime - onlyOnGoing;
        let hour = Math.floor(newTime / 3600).toString();
        let min = (Math.floor(newTime / 60) % 60).toString();
        let sec = (newTime % 60).toString();
        return [hour, min, sec].map(item => {
            if (+item < 10) {
                item = "0" + item;
            }
            return item;
        });
    }
    return [];
};
export const secToTimeArr = (leftTime) => {
    let result = {
        hour: "",
        min: "",
        sec: "",
    };
    if (leftTime > -1) {
        let hour = Math.floor(leftTime / 3600).toString();
        let min = (Math.floor(leftTime / 60) % 60).toString();
        let s = (leftTime % 60).toString();
        if (Number(hour) < 10) {
            hour = "0" + hour;
        }
        result.hour = hour;
        if (Number(min) < 10) {
            min = "0" + min;
        }
        result.min = min;
        if (Number(s) < 10) {
            s = "0" + s;
        }
        result.sec = s;
    }
    return result;
};
export const SECONDS_IN_A_DAY = 24 * 60 * 60;
export const EnFormateDays = (sec) => {
    if (sec && sec > 0) {
        return Math.floor(sec / SECONDS_IN_A_DAY);
    }
    return 0;
};
export const endUnit = (language = "en") => {
    switch (language) {
        case "no":
            return "Dager";
        case "pt":
            return "Dias";
        case "es":
            return "Días";
        case "de":
            return "Tag";
        default:
            return "days";
    }
};
